import React from 'react';
import '../styles/fonts.css';
import ContactForm from './ContactForm';

const gradientTextStyle = {
    background: 'linear-gradient(to right, #ff0000 5%, #ff8c00 10%, #ffd700 65%, #ff69b4 85%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
};

function Partners() {
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = {
            name: formData.get('name'),
            phone: formData.get('phone'),
            email: formData.get('email'),
            message: formData.get('message')
        };

        // Log the form data (replace with your actual submission logic)
        console.log('Form submitted:', data);

        // Clear the form
        e.target.reset();

        // You can add your API call here
        // Example:
        // fetch('/api/contact', {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify(data),
        // });
    };

    return (
        <div className="overflow-hidden" style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
        }}>
            <div className="gradient-circle gradient-circle-left"></div>
            <div className="gradient-circle gradient-circle-right"></div>
            <div className="container-fluid px-4 px-md-5 pt-4" style={{ maxWidth: '1728px', margin: '0 auto' }}>
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10">
                        {[
                            {
                                title: "Technology & IT Services (Hardware & Software)",
                                images: [
                                    { src: "/partner/hewlett.png", alt: "Server 2" },
                                    { src: "/partner/microsoft.png", alt: "Server 3" },
                                    { src: "/partner/vmware.png", alt: "Server 4" },
                                    { src: "/partner/lenovo.png", alt: "Server 5" },
                                    { src: "/partner/huawei.png", alt: "Server 6" },
                                    { src: "/partner/aws.png", alt: "Server 7" },
                                    { src: "/partner/cisco.png", alt: "Server 8" },
                                    { src: "/partner/dell.png", alt: "Server 9" },
                                    { src: "/partner/hp.png", alt: "Server 10" }
                                ]
                            },
                            {
                                title: "Cybersecurity",
                                images: [
                                    { src: "/partner/trendmicro.png", alt: "Cloud 1" },
                                    { src: "/partner/checkpoint.png", alt: "Cloud 2" },
                                    { src: "/partner/paloalto.png", alt: "Cloud 3" },
                                    { src: "/partner/fortinet.png", alt: "Cloud 4" },
                                    { src: "/partner/tenable.png", alt: "Cloud 5" },
                                    { src: "/partner/forcepoint.png", alt: "Cloud 6" },
                                    { src: "/partner/cyble.png", alt: "Cloud 7" },
                                    { src: "/partner/a10.png", alt: "Cloud 8" },
                                    { src: "/partner/stratus.png", alt: "Cloud 9" },
                                    { src: "/partner/devo.png", alt: "Cloud 10" }
                                ]
                            },
                            {
                                title: "Networking & Cloud Solutions",
                                images: [
                                    { src: "/partner/veenam.png", alt: "Security 1" },
                                    { src: "/partner/netscout.png", alt: "Security 2" },
                                    { src: "/partner/commvault.png", alt: "Security 3" },
                                    { src: "/partner/cloudwise.png", alt: "Security 4" },
                                    { src: "/partner/sangfor.png", alt: "Security 5" },
                                ]
                            },
                            {
                                title: "Enterprise Solutions",
                                images: [
                                    { src: "/partner/dahua.png", alt: "Software 1" },
                                    { src: "/partner/apc.png", alt: "Software 2" },
                                    { src: "/partner/vertiv.png", alt: "Software 3" },
                                    { src: "/partner/epson.png", alt: "Software 4" },
                                    { src: "/partner/canon.png", alt: "Software 5" },
                                ]
                            },
                        ].map((section, sectionIndex) => (
                            <div key={sectionIndex} className="mb-4">
                                <h3 className="text-start text-muted mb-3" style={{
                                    fontFamily: 'Avenir, sans-serif',
                                    fontWeight: 'bold',
                                    fontSize: window.innerWidth < 768 ? '20px' : '24px',
                                }}>
                                    {section.title}
                                </h3>

                                {/* Images grid with responsive layout */}
                                <div className="row row-cols-2 row-cols-md-5 px-3">
                                    {section.images.map((image, imgIndex) => (
                                        <div key={imgIndex} className="col">
                                            <div style={{ position: 'relative', paddingBottom: '60%' }}>
                                                <img
                                                    src={image.src}
                                                    alt={image.alt}
                                                    className="img-fluid"
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                        maxWidth: '70%',
                                                        maxHeight: '70%',
                                                        width: 'auto',
                                                        height: 'auto',
                                                        objectFit: 'contain',
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="container-fluid px-4 px-md-5 py-3" style={{ maxWidth: '1728px', margin: '0 auto' }}>
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10">
                        <h1 className="display-4 text-start mb-0"
                            style={{
                                ...gradientTextStyle,
                                fontFamily: 'Godber, sans-serif',
                                fontSize: window.innerWidth < 768 ? '32px' : '40px'
                            }}>
                            Experts
                        </h1>
                        <h2 className="text-start" style={{ 
                            fontFamily: 'Avenir, sans-serif', 
                            fontSize: window.innerWidth < 768 ? '28px' : '36px', 
                            fontWeight: 'bold' 
                        }}>
                            Why Choose Us?
                        </h2>

                        <p className='text-start' style={{ 
                            fontFamily: 'Avenir, sans-serif', 
                            fontSize: window.innerWidth < 768 ? '18px' : '24px' 
                        }}>
                            At Cresco, we are committed to delivering scalable, secure, and future-proof IT solutions that empower businesses across industries. No matter the sector, our expertise ensures that your technology investments align with your business goals and industry requirements.
                        </p>

                        <p className='text-start' style={{ 
                            fontFamily: 'Avenir, sans-serif', 
                            fontSize: window.innerWidth < 768 ? '18px' : '24px' 
                        }}>
                            We build technology-driven strategies that empower businesses to thrive in the digital era. Whether you need custom software, IT infrastructure, cybersecurity, or digital transformation, we are your trusted technology partner
                        </p>
                    </div>
                </div>
            </div>

            {/* Services Section */}
            <div className="container-fluid px-4 px-md-5 py-3" style={{ maxWidth: '1728px', margin: '0 auto' }}>
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10">
                        <h1 className="display-4 text-start mb-0"
                            style={{
                                ...gradientTextStyle,
                                fontFamily: 'Godber, sans-serif',
                                fontSize: window.innerWidth < 768 ? '32px' : '40px'
                            }}>
                            Our Services
                        </h1>
                        <div className="row d-flex align-items-center justify-content-between mb-4">
                            <div className="col-auto">
                                <h2 className="mb-2 text-start" style={{ 
                                    fontFamily: 'Avenir, sans-serif', 
                                    fontSize: window.innerWidth < 768 ? '28px' : '36px', 
                                    fontWeight: 'bold' 
                                }}>
                                    Tech-Driven, Future Ready
                                </h2>
                            </div>
                            <div className="col-auto">
                                <button className="btn rounded-0"
                                    onClick={() => window.location.href = '/services'}
                                    style={{
                                        width: '200px',
                                        height: '56px',
                                        backgroundColor: '#BC2025',
                                        color: 'white',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        fontFamily: 'Avenir, sans-serif'
                                    }}>
                                    <span className="me-3">Our Services</span>
                                    <img src="/arrow.png" alt="arrow" style={{ width: '20px', height: '20px' }} />
                                </button>
                            </div>
                        </div>

                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-2">
                            <div className="col">
                                <div className="card border-0" style={{ backgroundColor: 'transparent' }}>
                                    <div className="card-body text-start">
                                        <h5 className="card-title mb-0" style={{
                                            color: '#BC2025',
                                            fontFamily: 'Godber, sans-serif',
                                            fontSize: window.innerWidth < 768 ? '24px' : '28px'
                                        }}>Digital Transformation</h5>
                                        <span className="card-text font-weight-bold d-flex align-items-center mb-3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '20px', fontWeight: 'bold' }}></i>
                                            <span>(Server Hardware)</span>
                                        </span>
                                        <img src="/services/digitalTransformation.png" alt="Server Hardware" className="img-fluid mb-3" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold',}}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Data Center Solutions</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Cloud Infrastructure Solutions</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Virtualization & Compute Solutions</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card border-0" style={{ backgroundColor: 'transparent' }}>
                                    <div className="card-body text-start">
                                        <h5 className="card-title mb-0" style={{
                                            color: '#BC2025',
                                            fontFamily: 'Godber, sans-serif',
                                            fontSize: window.innerWidth < 768 ? '24px' : '28px'
                                        }}>Enterprise Solutions</h5>
                                        <span className="card-text font-weight-bold d-flex align-items-center mb-3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '20px', fontWeight: 'bold' }}></i>
                                            <span>(System Integration)</span>
                                        </span>
                                        <img src="/services/systemIntegration.png" alt="System Integration" className="img-fluid mb-3" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>ERP & CRM Integration</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>IT Infrastructure Integration</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Cybersecurity Integration</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card border-0" style={{ backgroundColor: 'transparent' }}>
                                    <div className="card-body text-start">
                                        <h5 className="card-title mb-0" style={{
                                            color: '#BC2025',
                                            fontFamily: 'Godber, sans-serif',
                                            fontSize: window.innerWidth < 768 ? '24px' : '28px'
                                        }}>Software Development</h5>
                                        <span className="card-text font-weight-bold d-flex align-items-center mb-3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '20px', fontWeight: 'bold' }}></i>
                                            <span>(Custom Applications)</span>
                                        </span>
                                        <img src="/services/customApplications.png" alt="Custom Applications" className="img-fluid mb-3" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Business Process Automation</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>AI & Data Analytics Platforms</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Mobile & Web Application Development</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card border-0" style={{ backgroundColor: 'transparent' }}>
                                    <div className="card-body text-start">
                                        <h5 className="card-title mb-0" style={{
                                            color: '#BC2025',
                                            fontFamily: 'Godber, sans-serif',
                                            fontSize: window.innerWidth < 768 ? '24px' : '28px'
                                        }}>Maintained & Support</h5>
                                        <span className="card-text font-weight-bold d-flex align-items-center mb-3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '20px', fontWeight: 'bold' }}></i>
                                            <span>(Managed Services)</span>
                                        </span>
                                        <img src="/services/manageService.png" alt="Managed Services" className="img-fluid mb-3" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>24/7 IT Support & Monitoring</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Backup & Disaster Recovery</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Software Updates & Patch Management</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Us Section */}
            <div className="container-fluid px-4 px-md-5 py-3" style={{ maxWidth: '1728px', margin: '0 auto' }}>    
                <ContactForm />
            </div>
        </div>
    );
}

export default Partners; 